import {FeedItemContainer} from "components/feed/FeedItem/FeedItemContainer";
import {FeedItemContent} from "components/feed/FeedItem/FeedItemContent";
import * as React from "react";
import {observer} from "mobx-react";
import {StringHelpers} from "shared/StringHelpers";
import {handleSpacePressed} from "utils";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";

interface IBoothConversationPostProps {
  post:any;
  presenter:any;
  onViewFullPost:()=>void;
}

@observer
export class BoothConversationPost extends React.Component<IBoothConversationPostProps> {


  render() {

    let icon:any;

    let bloggerIcon = '/res_sys/blogger_face.jpg';
    if(this.props.presenter && this.props.presenter.avatar) {
      if(this.props.presenter.avatar.indexOf('/res/')===0) {
        bloggerIcon = this.props.presenter.avatar;
      } else {
        bloggerIcon = '/usercontent/'+this.props.presenter.avatar;
      }
    }
    icon = <span className="solution" aria-hidden={true}><span className="face"><img src={bloggerIcon} /></span></span>;
    const commentsText = this.props.post && this.props.post.commenting ? " ("+this.props.post.comments.length+" comment"+(1==this.props.post.comments.length?"":"s")+")": "";
    let hasFullPost = false;
    if(this.props.post.fullPost){
      const fp = StringHelpers.safeHTML(this.props.post.fullPost.trim());
      if(null!=fp) {
        hasFullPost = true;
      }
    }

    return (
      <div className={'booth-conversation-post'}>
        <FeedItemContainer completed={true}>

          {icon}

          <div>
            <FeedItemContent title={this.props.post.title} feedItemContext={'bundle-conversation'}>
              <HeaderLevelCorrectedContent className="text" content={this.props.post.content} offset={'bundle-conversation'} />
            </FeedItemContent>
            <div className="actions">
              { hasFullPost  && <a tabIndex={0}
                                   className="action"
                                   onClick={this.props.onViewFullPost}
                                   onKeyDown={(e)=>{ handleSpacePressed(e, this.props.onViewFullPost);}}
              >{this.props.post.commenting ? `SHARE COMMENTS ${commentsText}` : "VIEW FULL POST"}</a>
              }
            </div>
          </div>

        </FeedItemContainer>
      </div>

    );

  }
}
